import styled from "styled-components";

type ContainerType = {
    background: string;
}

type ContentEditType = {
    canChange: boolean;
    color: string;
}

type LineClampType = {
    width: number;
}

type IconType = {
    color: string;
    size: number;
}

type TextType = {
    color: string;
}

export const Container = styled.div`
    padding: 0 16px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    width: 100%;
    background: transparent;
    height: 65px;
    min-height: 65px;
    max-height: 65px;
`;

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const ContentDataInternalChat = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
`;

export const ContainerDescription = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 10px;
`;

export const IconEdit = styled.i<IconType>`
    font-size: ${props => props.size}px;
    color: ${props => props.color};
    cursor: pointer;
    display: none;
    pointer-events: none;
    margin-left: 3px;
`;

export const ContainerEditDescription = styled.div<ContentEditType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 20px;
    max-height: 20px;
    width: fit-content;

    &:hover ${IconEdit} {
        display: ${(props) => props.canChange ? 'inline' : 'none'};
    }

    &:hover {
        text-decoration: ${(props) => props.canChange ? 'underline' : 'auto'};
        text-decoration-color: ${props => props.color};
        cursor: ${(props) => props.canChange ? 'pointer' : 'auto'};
    }
`;

export const ContentLineClamp = styled.div<LineClampType>`
    display: block;
    max-width: calc((100vw - ${props => `${props.width}px`}) / ${props => 1}) !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
`;

export const TextDescriptionProblem = styled.span<TextType>`
    font-size: 15px;
    color: ${props => props.color};
    text-align: left;
`;

export const TextOpenedByUser = styled.span<TextType>`
    font-size: 13px;
    color: ${props => props.color};
    text-align: left;
`;